<template>
  <div class="question-edit" @mousemove="mousemove" @mouseleave="emitData" @click="setUeEditorShow(false)">
    <el-form :model="question" :rules="rules" ref="form" label-width="55px">
      <div class="fx-box">
        <el-form-item label="" prop="questionType" class="is-required">
          <template slot="label">
            <span @dblclick="question.typeEdit = !question.typeEdit">题类</span>
          </template>
          <question-types :is-children="!!data.parentId" v-model="question.questionType" @change="questionTypeChange" style="width:150px" :disabled="!!question.id && !question.typeEdit" :clearable="false"></question-types>
        </el-form-item>
        <el-form-item label="题型" prop="questionTypeTag" class="is-required">
          <question-tags v-model="question.questionTypeTag" style="width:150px;" :type="1" :cache="type=='upload'" :update="update"></question-tags>
        </el-form-item>
        <el-form-item label="专业课程" prop="subjectCatalogueId" label-width="90px">
          <professional-list style="width:150px;" v-if="platform == 'pc'" v-model="question.subjectCatalogueId"></professional-list>
          <professional-tree :root="1" v-model="question.subjectCatalogueId" v-else :config="{ 'checkStrictly': false }" style="width:150px" :clearable="false" @change="subjectCatalogueChange"></professional-tree>
        </el-form-item>
        <el-form-item label="难度星级" prop="difficulty" label-width="90px" class="is-required">
          <el-rate v-model="question.difficulty" class="mt-5" :colors="['#f56c6c', '#f56c6c', '#f56c6c']" disabled-void-color="#ccc" style="width:150px;">
          </el-rate>
        </el-form-item>
        <!-- <el-form-item label="认证类型" prop="attestationType" label-width="90px" v-if="type == 'all'">
          <el-select v-model="question.attestationType" placeholder="请选择" :clearable="true" style="width:150px">
            <el-option label="练习" :value="1"></el-option>
            <el-option label="认证" :value="2"></el-option>
          </el-select>
        </el-form-item> -->
      </div>
      <div class="fx-box" v-if="type == 'industry'">
        <el-form-item label="时间" prop="year">
          <el-date-picker v-model="question.year" type="date" placeholder="选择日期" style="width:150px"></el-date-picker>
        </el-form-item>
        <el-form-item label="地区" prop="address">
          <el-select v-model="question.address" placeholder="请选择" style="width:150px;">
            <el-option v-for="item in provinceAndCityData" :key="item.value" :label="item.label" :value="item.label">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="来源类型" prop="source" label-width="90px">
          <source-list v-model="question.sourceTypeId" style="width:150px;"></source-list>
        </el-form-item>
        <el-form-item label="是否母题" prop="isMatrix" v-if="showMatrix" label-width="90px">
          <el-radio-group v-model="question.isMatrix" size="small">
            <el-radio :label="true">是</el-radio>
            <!-- <el-radio :label="false" border disabled>变式题</el-radio> -->
            <el-radio :label="null">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="题目来源" prop="source" label-width="90px">
          <el-input v-model="question.source" autocomplete="off" clearable placeholder="请输入" style="width:220px"></el-input>
        </el-form-item>
      </div>
      <el-form-item label="题干" prop="content" class="is-required">
        <div @click.stop class="inputs">
          <div v-html="question.content" v-if="!question.contentShow" class="input-editor content-html" :class="{ 'empty': !question.content }" @click="showUeEditor('contentShow')"></div>
          <ue-editor :height="200" v-model="question.content" v-if="question.contentShow" type="question" @change="editorCallback" :marktk="question.questionType == 5"></ue-editor>
        </div>
      </el-form-item>
      <el-form-item label="内容" prop="options" v-if="question.questionType == 1 || question.questionType == 2 || question.questionType == 4" class="is-required">
        <div class="options">
          <el-button type="primary" size="mini" class="add-options" @click="addOptions()">添加项目</el-button>
          <div class="option-list" v-for="(item, index) in question.questionOptionViewModels" :key="index">
            <span class="order type4" :class="{ 'active': question.answer.findIndex(s => s.orderSort == item.orderSort) >= 0 }" v-if="question.questionType == 4" @click="selectOrder(item, index)" v-html="item.orderSort"></span>
            <span class="order" v-else>{{ getEN(index) }}</span>
            <div @click.stop class="inputs">
              <div class="input-editor content-html" v-html="item.optionContent" :class="{ 'empty': !item.optionContent }" v-if="!item.optionShow" @click="showUeEditor('optionShow', item)"></div>
              <ue-editor :height="200" v-model="item.optionContent" v-if="item.optionShow" type="question" @change="editorCallback"></ue-editor>
              <span @click="deletedOptions(item, index)" class="deleted-btn el-icon-remove"></span>
            </div>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="答案" prop="questionAnswer" class="is-required" v-if="question.questionType != 6">
        <ul class="select-answer" v-if="question.questionType == 1 || question.questionType == 2">
          <li :class="{ 'active': item.isTrue }" v-for="(item, index) in question.questionOptionViewModels" :key="index" @click="setSelectAnswer(item)">{{ getEN(index) }}</li>
          <li style="border:none;width:auto;">
            <span style="color:#aaa" class="font-13 ml-5">点击答案选项选择参考答案</span>
          </li>
        </ul>
        <ul class="judge-fill-answer" v-else-if="question.questionType == 3">
          <span @click="addAnswer(index)" class="el-icon-circle-plus edit-btn" v-if="question.answer.length == 0"></span>
          <li v-for="(item, index) in question.answer" :key="index" class="center">
            <span class="order" :class="['type' + question.questionType]">{{ index + 1 }}</span>
            <el-radio-group v-model="item.answerArray" size="mini">
              <el-radio-button label="true"><span class="answer-label el-icon-check"></span></el-radio-button>
              <el-radio-button label="false"><span class="answer-label el-icon-close"></span></el-radio-button>
            </el-radio-group>
            <span class="edit">
              <span @click="addAnswer(index)" class="el-icon-circle-plus edit-btn" title="添加平级答案"></span>
              <span @click="deleteAnswer(index)" class="el-icon-remove edit-btn" title="删除答案"></span>
            </span>
          </li>
        </ul>
        <ul class="order-answer" v-else-if="question.questionType == 4">
          <li class="order-sort" v-for="(item, index) in question.answer" :key="index" v-html="item.orderSort"></li>
          <li style="border:none;width:auto;">
            <span style="color:#aaa" class="font-13 ml-5">点击内容选项中序号排列顺序</span>
          </li>
        </ul>
        <ul class="judge-fill-answer" v-else>
          <span @click="addAnswer(index)" class="el-icon-circle-plus edit-btn" v-if="question.answer.length == 0"></span>
          <li v-for="(item, index) in question.answer" :key="index" class="mb-5">
            <span class="order" :class="['type' + question.questionType]">{{ index + 1 }}</span>
            <div @click.stop class="inputs">
              <div class="input-editor content-html" v-html="item.answerContent" :class="{ 'empty': !item.answerContent }" v-if="!item.optionShow" @click="showUeEditor('optionShow', item)"></div>
              <ue-editor :height="200" v-model="item.answerContent" v-if="item.optionShow" type="question" @change="editorCallback"></ue-editor>
              <div class="similar-box">
                <div class="similar-item" v-for="(sim, sort) in item.similarityAnswers" :key="sort">
                  <div class="input-editor content-html" v-html="sim.answerContent" :class="{ 'empty': !sim.answerContent }" v-if="!sim.optionShow" @click="showUeEditor('optionShow', sim)"></div>
                  <ue-editor :height="200" v-model="sim.answerContent" v-if="sim.optionShow" type="question" @change="editorCallback"></ue-editor>
                  <span class="edit">
                    <span @click="addSimilarAnswer(item, sort)" class="el-icon-circle-plus edit-btn" title="添加平级答案"></span>
                    <span @click="deleteSimilarAnswer(item, sort)" class="el-icon-remove edit-btn" title="删除答案"></span>
                  </span>
                </div>
              </div>
            </div>
            <span class="edit">
              <span @click="addAnswer(index)" class="el-icon-circle-plus edit-btn" title="添加平级答案"></span>
              <span @click="deleteAnswer(index)" class="el-icon-remove edit-btn" title="删除答案"></span>
              <span @click="addSimilarAnswer(item)" class="el-icon-caret-bottom edit-btn" title="添加相似答案"></span>
            </span>
          </li>
        </ul>
      </el-form-item>
      <el-form-item label="解析" prop="questionAnswerAnalysisContent">
        <div @click.stop class="inputs">
          <div v-html="question.questionAnswerAnalysisContent" :class="{ 'empty': !question.questionAnswerAnalysisContent }" v-if="!question.questionAnswerAnalysisContentShow" class="input-editor content-html"
            @click="showUeEditor('questionAnswerAnalysisContentShow')"></div>
          <ue-editor :height="200" v-model="question.questionAnswerAnalysisContent" v-if="question.questionAnswerAnalysisContentShow" type="question" @change="editorCallback"></ue-editor>
        </div>
      </el-form-item>
      <template v-if="platform == 'pc'">
        <el-form-item label="知识点" prop="knowledgePoints" class="fx-1">
          <knowledge-list style="width: 75%;" :disabled="!question.subjectCatalogueId" v-model="question.knowledgePoints" :defaults="question.knowledgePointViewModels" :subjectCatalogueId="question.subjectCatalogueId" :multiple="true"
            @change="knowledgePointChange"></knowledge-list>
          <p v-if="!question.subjectCatalogueId" class="mt-5 color-999" v-show="type!='upload'">注：编辑编辑知识点需选择专业课程</p>
        </el-form-item>
      </template>
      <template v-else>
        <el-form-item label="知识点" prop="knowledgePoints" label-width="70px" class="fx-1">
          <knowledge-list style="width: 75%;" :disabled="!question.subjectCatalogueId" v-model="question.knowledgePoints" :defaults="question.knowledgePointViewModels" :subjectCatalogueId="question.subjectCatalogueId" :multiple="true"
            @change="knowledgePointChange"></knowledge-list>
        </el-form-item>
        <el-form-item label="问题类型" prop="variantId" label-width="70px" class="fx-1">
          <variant-cascader :disabled="!question.subjectCatalogueId" v-model="question.variantId" :subjectCatalogueId="question.subjectCatalogueId" @change="emitData"></variant-cascader>
          <p v-if="!question.subjectCatalogueId" class="mt-5 color-999" v-show="type!='upload'">注：编辑编辑知识点和问题类型需选择专业课程</p>
        </el-form-item>
      </template>
      <el-form-item label="排序号" prop="sort" v-if="question.parentId">
        <el-input-number v-model="question.sort" :min="0" :max="10000" placeholder="请输入"></el-input-number>
      </el-form-item>
    </el-form>
    <el-checkbox v-model="question.isVerification" v-if="showVerification" style="position: absolute;top: 0px;right: 20px;">已检查</el-checkbox>
  </div>
</template>
<script>
import { provinceAndCityData } from 'element-china-area-data'
export default {
  components: {

  },
  props: {
    value: "",
    update: false,
    type: {
      type: String,
      default: "all",
    },
    data: {
      type: Object,
      default: () => { return {} },
    },
    showMatrix: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      question: {
        answer: [],
      },
      rules: {
      },
      initForm: {
        id: "",
        parentId: "",
        questionType: 1,
        classify: 1,
        difficulty: 1,
        content: "",
        questionOptionViewModels: [],
        knowledgePointViewModels: [],
        knowledgePoints: [],
        source: "",
        sourceTypeId: "",
        year: "",
        questionObjectiveAnswerViewModels: [],
        curriculumChapterId: "",
        subjectCatalogueId: "",
        subjectCatalogueParentId: "",
        answer: [],
        classLevel: "",
        isMatrix: null,
        isVerification: false,
        questionTypeTag: "",
        tags: [],
        variantId: "",
      },
      questionString: "",
      radio: "",
      currentItem: {},
      provinceAndCityData,
      showVerification: false,
      platform: this.$root.tenantInfo.code == '1' ? 'ms' : location.pathname.replace(/\//g, "") || "pc",
    }
  },
  watch: {
    update(val) {
      this.setData();
    },
    questionString(newVal, oldVal) {
      this.emitData();
    },
  },
  created() {
    if (this.$route.path == "/resource/set-curriculum" || this.$route.path == "/resource/question" || this.$route.path == "/resource/errors") {
      this.showVerification = true;
    }
  },
  beforeDestroy() {
    this.$bus.$off('Edit_Qustion');
  },
  mounted() {
    this.$bus.$on("Edit_Qustion", (data) => {
      if (data.id !== this.question.id) {
        this.setUeEditorShow(false);
      }
    })
    this.setData();
  },
  methods: {
    forceUpdate() {
      this.$forceUpdate();
    },
    setData() {
      if (this.value && this.value.id) {
        this.question = this.func.depCopy(this.value);
      } if (this.data && this.data.id) {
        this.question = this.func.depCopy(this.data);
      } else {
        this.question = Object.assign(this.func.depCopy(this.initForm), this.data);
      }
      this.question.questionOptionViewModels = this.question.questionOptionViewModels || [];
      this.question.questionObjectiveAnswerViewModels = this.question.questionObjectiveAnswerViewModels || [];
      this.formartData();
      this.question.knowledgePoints = [];
      this.question.knowledgePointViewModels.map(item => {
        if (item.id || item.name) {
          this.question.knowledgePoints.push(item.id || item.name);
        }
      });
      if (this.question.curriculumChapterId) {
        this.question.classification = 2;
      } else {
        this.question.classification = 1;
      }
      if (this.question.year) {
        this.question.year = this.func.formatDate(this.question.year, "yyyy-MM-dd");
      }
      this.question.isVerification = this.question.isVerification || false;
      this.question.questionTypeTag = this.question.questionTypeTag || this.func.questionType(this.question.questionType);
      this.question.tags = this.question.tags || [];
      this.questionTypeChange();
    },
    formartData() {
      if (this.question.content) {
        this.question.content = this.question.content.replace(/font-size:24px/g, "");
      }
      this.question.questionOptionViewModels.map(item => {
        item.optionContent = item.optionContent || "";
        item.optionContent = item.optionContent.replace(/font-size:24px/g, "");
      })
      this.question.questionObjectiveAnswerViewModels.map(item => {
        item.answerContent = item.answerContent || "";
        item.answerContent = item.answerContent.replace(/font-size:24px/g, "");
      })
      if (this.question.questionAnswerAnalysisContent) {
        this.question.questionAnswerAnalysisContent = this.question.questionAnswerAnalysisContent.replace(/font-size:24px/g, "");
      }
    },
    handleClose() {
      this.$emit("callback", 'hide');
    },
    getEN(i) {
      return String.fromCharCode(i + 65);
    },
    setUeEditorShow(val) {
      this.question.contentShow = val;
      this.question.questionAnswerAnalysisContentShow = val;
      this.question.questionOptionViewModels = this.question.questionOptionViewModels || [];
      this.question.questionOptionViewModels.map(item => {
        item.optionShow = val;
      })
      this.question.answer = this.question.answer || [];
      this.question.answer.map(item => {
        if (item instanceof Object) {
          item.optionShow = val;
        }
        if (item.similarityAnswers && item.similarityAnswers.length > 0) {
          item.similarityAnswers.map(sim => {
            if (sim instanceof Object) {
              sim.optionShow = val;
            }
          })
        }
      });
      this.emitData();
    },
    editorCallback(content, text) {
      if (this.currentItem) {
        this.currentItem.value = text;
      }
    },
    showUeEditor(type, item) {
      this.currentItem = item;
      this.$bus.$emit("Edit_Qustion", this.question);
      this.setUeEditorShow(false);
      if (item) {
        item[type] = true;
      } else {
        this.question[type] = true;
      }
      this.formartData();
      // this.question = this.func.depCopy(this.question);
    },
    showSimUeEditor(type, item) {
      this.currentItem = item;
      this.$bus.$emit("Edit_Qustion", this.question);
      if (item) {
        item[type] = true;
      } else {
        this.question[type] = true;
      }
      this.formartData();
    },
    addOptions(content) {
      this.question.questionOptionViewModels.push({
        id: "",
        content: content || "",
        isTrue: false,
        orderSort: this.question.questionOptionViewModels.length + 1,
      })
    },
    deletedOptions(data, index) {
      this.question.questionOptionViewModels.splice(index, 1);
      this.question.questionOptionViewModels.map((item, index) => {
        item.lastOrderSort = item.orderSort;
        item.orderSort = index + 1;
      })
      if (this.question.questionType == 4) {
        let index = this.question.answer.findIndex(item => data.orderSort == item);
        if (index >= 0) {
          this.question.answer.splice(index, 1);
          var arr = this.question.answer.map(item => {
            let obj = this.question.questionOptionViewModels.find(a => a.lastOrderSort == item);
            return obj.orderSort;
          })
          this.question.answer = arr;
        }
      }
    },
    setSelectAnswer(item) {
      if (this.question.questionType == 1 || this.question.questionType == 3) {
        this.question.questionOptionViewModels.map(item => {
          item.isTrue = false;
        })
        item.isTrue = true;
      } else {
        item.isTrue = !item.isTrue;
      }
    },
    selectOrder(data) {
      let index = this.question.answer.findIndex(item => data.orderSort == item.orderSort);
      if (index < 0) {
        data.answerArray = data.orderSort;
        this.question.answer.push(data);
      } else {
        this.question.answer.splice(index, 1);
      }
    },
    mousemove() {
      this.questionString = JSON.stringify(this.question);
    },
    knowledgePointChange(datas) {
      this.question.knowledgePointViewModels = datas;
      this.emitData();
    },
    subjectCatalogueChange(data) {
      this.question.knowledgePoints = this.question.knowledgePoints.filter(item => item.subjectCatalogueId == data.id);
      this.question.variantId = "";
      this.emitData();
    },
    emitData() {
      let question = this.func.depCopy(this.question);
      question.questionObjectiveAnswerViewModels = question.answer || [];
      question.year = this.func.formatDate(question.year, "yyyy-MM-dd");
      if (question.questionTypeTag) {
        let typeObj = {
          type: 1,
          name: question.questionTypeTag,
        }
        let index = question.tags.findIndex(item => item.type == 1);
        if (index < 0) {
          question.tags.push(typeObj);
        } else {
          question.tags[index] = typeObj;
        }
      }
      delete question.contentShow;
      delete question.questionAnswerAnalysisContentShow;
      delete question.answer;
      if (question.questionType == 1 || question.questionType == 2) {
        question.optionAnswer = [];
        question.questionOptionViewModels.map((item, index) => {
          item.optionTitle = this.getText(item.optionContent);
          delete item.optionShow;
          item.orderSort = index + 1;
          if (item.isTrue) {
            question.optionAnswer.push(this.getEN(index));
          }
        });
        question.questionObjectiveAnswerViewModels = [];
      } else if (question.questionType == 3) {
        question.questionObjectiveAnswerViewModels.map(item => {
          item.id = item.id || "";
          item.answerArray = item.answerArray;
          if (item.answerArray + "" == "true") {
            item.answerContent = "√";
            item.answerTitle = "√";
          } else {
            item.answerContent = "×";
            item.answerTitle = "×";
          }
          delete item.optionShow;
        })
        question.questionOptionViewModels = [];
      } else if (question.questionType == 4) {
        question.questionObjectiveAnswerViewModels.map(item => {
          item.id = item.id || "";
          item.answerContent = item.answerArray;
          item.answerTitle = item.answerArray;
          delete item.optionShow;
        })
      } else {
        question.questionObjectiveAnswerViewModels.map(item => {
          item.id = item.id || "";
          item.answerArray = this.getText(item.answerContent);
          item.answerTitle = item.answerArray;
          item.similarityAnswers.map(sim => {
            sim.answerArray = this.getText(sim.answerContent);
            item.answerTitle = item.answerArray;
            delete sim.optionShow;
          })
          delete item.optionShow;
        });
        question.questionOptionViewModels = [];
      };
      this.forceUpdate();
      this.$emit("input", question);
      this.$emit("callback", question);
    },
    getText(str) {
      if (!str) {
        return "";
      }
      return str.replace(/<[^<>]+>/g, "").replace(/&nbsp;/gi, "");
    },
    questionTypeChange(val) {
      if (val) {
        this.question.questionTypeTag = "";
      }
      if (this.question.questionType == 1 || this.question.questionType == 2) {
        if (this.question.questionOptionViewModels.length == 0) {
          for (let i = 0; i < 4; i++) {
            this.addOptions("");
          }
        }
      } else if (this.question.questionType == 3) {
        if (val) {
          this.question.answer = [];
        } else {
          this.question.answer = this.question.questionObjectiveAnswerViewModels;
          this.question.answer.map(item => {
            item.answerArray = item.answerArray.toLowerCase();
          });
        }
      } else if (this.question.questionType == 4) {
        if (val) {
          this.question.answer = [];
        } else {
          this.question.questionObjectiveAnswerViewModels.map(item => {
            try {
              item.orderSort = this.getText(item.answerArray || item.answerContent);
            } catch (error) { }
          });
          this.question.answer = this.question.questionObjectiveAnswerViewModels;
        }
      } else {
        if (val) {
          this.question.answer = [];
        } else {
          this.question.answer = this.question.questionObjectiveAnswerViewModels;
        }
      }
      this.questionString = JSON.stringify(this.question);
    },
    professionalChange(data) {
      this.question.knowledgePoints = [];
      this.question.subjectCatalogueParentId = data.parentId;
    },
    addAnswer(index) {
      this.question.answer.splice(index + 1, 0, { id: "", answerContent: "", similarityAnswers: [] })
    },
    deleteAnswer(index) {
      this.question.answer.splice(index, 1);
    },
    addSimilarAnswer(item, index) {
      if (index >= 0) {
        item.similarityAnswers.splice(index + 1, 0, {
          id: "",
          answerContent: "",
        })
      } else {
        item.similarityAnswers.push({
          id: "",
          answerContent: "",
        })
      }
    },
    deleteSimilarAnswer(item, index) {
      item.similarityAnswers.splice(index, 1);
    },
    questionCheck(data) {
      if (!data.questionTypeTag) {
        this.func.message("error", "请选择或输入题型");
        return false;
      }
      if (!data.content) {
        this.func.message("error", "请输入题干");
        return false;
      }
      if (data.questionType == 1 || data.questionType == 2) {
        if (data.optionAnswer.length == 0) {
          this.func.message("error", "请选择答案");
          return false;
        }
        let tag = false;
        data.questionOptionViewModels.map(item => {
          if (!item.optionContent && !item.optionTitle) {
            tag = true;
          }
        })
        if (tag) {
          this.func.message("error", "请设选项答案");
          return false;
        }
      } else if (data.questionType != 6) {
        if (data.questionObjectiveAnswerViewModels.length == 0) {
          this.func.message("error", "请设置答案");
          return false;
        }
        let tag = false;
        data.questionObjectiveAnswerViewModels.map(item => {
          if (!item.answerContent && !item.answerArray) {
            tag = true;
          }
          if (item.similarityAnswers && item.similarityAnswers.find(item => !item.answerContent && !item.answerArray)) {
            tag = true;
          }
        })
        if (tag) {
          this.func.message("error", "请设置答案");
          return false;
        }
      }
      return true;
    },
    lookMatrix() {
      this.$emit("callback", "matrix");
    },
  },
}
</script>
<style>
.question-edit .judge-fill-answer .el-radio-button--mini {
  margin: 0 5px;
}

.question-edit
  .judge-fill-answer
  .el-radio-button--mini
  .el-radio-button__inner {
  padding: 0;
  border: none !important;
  box-shadow: none;
}

.question-edit table th,
.question-edit table td {
  padding: 5px;
}

.question-edit .input-answer .el-textarea__inner,
.question-edit .input-answer .el-input__inner {
  font-size: 14px;
  color: #555;
}

.question-edit .el-form-item--small.el-form-item {
  margin-bottom: 10px;
}
</style>
<style lang="scss" scoped>
.question-edit {
  position: relative;
  height: 100%;
  .fx-box {
    display: flex;
    flex-wrap: wrap;
  }

  .input-editor {
    border: 1px solid #ddd;
    padding: 5px 10px;
    border-radius: 4px;
    line-height: 1.3;
    min-height: 28px;

    &.choice {
      position: relative;
    }

    &:hover {
      border: 1px solid #ccc;
      cursor: pointer;
    }

    &.empty {
      &::before {
        content: "请输入内容";
        color: #ccc;
      }
    }
  }

  .options {
    border: 1px solid #ddd;
    padding: 28px 20px 15px;
    position: relative;
    border-radius: 2px;

    .add-options {
      position: absolute;
      right: 0;
      top: 0px;
      padding: 4px 10px;
    }

    .option-list {
      display: flex;
      padding-right: 25px;
      position: relative;

      &:last-child {
        margin-bottom: 0px;
      }

      .order {
        margin-right: 5px;
        white-space: nowrap;
        line-height: 20px;
        margin-top: 2px;

        &.type4 {
          display: inline-block;
          border: 1px solid #aaa;
          width: 20px;
          height: 20px;
          text-align: center;
          border-radius: 50%;
          line-height: 20px;
          vertical-align: middle;
          margin-top: 5px;
          font-size: 13px;

          &:hover {
            cursor: pointer;
            background-color: #e8f8f8;
          }

          &.active {
            background-color: #36bdcd;
            color: #fff;
            border-color: #36bdcd;
          }
        }
      }

      .inputs {
        flex: 1;
      }

      .deleted-btn {
        position: absolute;
        right: 0;
        top: 0;
        font-size: 20px;
        color: #f56c6c;
        top: 50%;
        transform: translate(0%, -50%);

        &:hover {
          cursor: pointer;
          opacity: 0.9;
        }
      }
    }

    .input-editor {
      border: 1px solid transparent;
      padding: 2px;
    }
  }

  .select-answer {
    position: relative;

    li {
      display: inline-block;
      border: 1px solid #ddd;
      width: 26px;
      height: 26px;
      line-height: 25px;
      text-align: center;
      margin-right: 8px;

      &:hover {
        cursor: pointer;
        background-color: #eee;
      }

      &.active {
        background-color: #36bdcd;
        color: #fff;
      }
    }
  }

  .judge-fill-answer {
    li {
      display: flex;

      &:last-child {
        margin-bottom: 0px;
      }

      .inputs {
        flex: 1;
      }

      &.center {
        align-items: center;
      }
    }

    .order {
      height: 20px;
      width: 20px;
      line-height: 20px;
      font-size: 12px;
      text-align: center;
      display: inline-block;
      vertical-align: middle;
      border: 1px solid #ddd;
      border-radius: 50%;
      margin-right: 5px;

      &.type5,
      &.type6,
      &.type7,
      &.type8,
      &.type9 {
        border-radius: 0;
        height: 30px;
        width: 30px;
        line-height: 30px;
        font-size: 13px;
      }
    }

    .answer-label {
      font-family: "微软雅黑";
      font-size: 14px;
      font-weight: 600;
      height: 22px;
      width: 22px;
      line-height: 22px;
      border: 1px solid #ddd;
    }

    .edit {
      margin-left: 10px;
      flex-shrink: 0;
      // width: 50px;
    }

    .edit-btn {
      font-size: 20px;
      display: inline-block;
      vertical-align: middle;
      color: #999;

      &:hover {
        cursor: pointer;
        opacity: 0.9;
      }

      &.el-icon-caret-bottom {
        background-color: #999;
        color: #fff;
        border-radius: 50%;
        width: 18px;
        height: 18px;
        font-size: 14px;
        text-align: center;
        line-height: 18px;
      }
    }
  }

  .order-answer {
    position: relative;

    li {
      display: inline-block;
    }

    .order-sort {
      display: inline-block;
      border: 1px solid #aaa;
      width: 22px;
      height: 22px;
      text-align: center;
      border-radius: 50%;
      line-height: 20px;
      font-size: 13px;
    }
  }

  .question-footer {
    margin-top: 25px;

    .el-button {
      min-width: 80px;
      margin: 0 10px;
    }
  }

  .similar-box {
    position: relative;

    .similar-item {
      display: flex;
      margin: 5px 0;

      .input-editor {
        flex: 1;

        &.empty {
          &::before {
            content: "请输入相似答案";
            color: #ccc;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/QuestionEdit.vue